import orderLabelTag from './orderLabelTag.vue';

export default orderLabelTag;
